/**
 * Anordnung der Termine im Stundenraster von Tag- und Wochenansicht (KON-070). Reine Rechnung auf den Uhrzeiten der Wand (Europe/Berlin), die
 * die Oberfläche ohnehin zeigt. Am Tag der Zeitumstellung hat das Raster trotzdem 24 Zeilen, ein Termin steht dort bei der Uhrzeit, die er trägt.
 */
const minutes = (time) => Number(time.slice(0, 2)) * 60 + Number(time.slice(3, 5));
/** Kürzeste Höhe, die ein Block bekommt, damit auch ein Termin von fünf Minuten lesbar bleibt */
export const MIN_BLOCK_MINUTES = 30;
/**
 * Die Blöcke eines Tages. Ein Termin, der über Mitternacht geht, steht am ersten Tag bis 24:00 und am zweiten ab 00:00. Termine, die sich überschneiden,
 * stehen nebeneinander und teilen sich die Breite. Ganztägige Termine gehören nicht ins Raster, sie stehen oben (`allDayOn`).
 *
 * Überschneidung rechnet mit der angezeigten Höhe, ein Termin von fünf Minuten belegt also 30 Minuten und verdrängt einen, der gleich danach beginnt.
 */
export function dayBlocks(appointments, day) {
    const items = appointments
        // Ein Termin, der genau um 00:00 Uhr des Tages endet, berührt ihn nicht
        .filter((a) => !a.allDay && a.start.slice(0, 10) <= day && a.end.slice(0, 10) >= day && a.end !== `${day}T00:00`)
        .map((a) => {
        const startMin = a.start.slice(0, 10) < day ? 0 : minutes(a.start.slice(11));
        const rawEnd = a.end.slice(0, 10) > day ? 1440 : minutes(a.end.slice(11));
        const endMin = Math.min(1440, Math.max(rawEnd, startMin + MIN_BLOCK_MINUTES));
        return { id: a.id, startMin: Math.min(startMin, 1440 - MIN_BLOCK_MINUTES), endMin };
    })
        .sort((a, b) => a.startMin - b.startMin || b.endMin - a.endMin || a.id.localeCompare(b.id));
    const blocks = [];
    let group = [];
    let groupEnd = -1;
    const closeGroup = () => {
        const columns = group.reduce((m, b) => Math.max(m, b.column + 1), 1);
        for (const b of group)
            b.columns = columns;
        blocks.push(...group);
        group = [];
    };
    for (const item of items) {
        if (group.length > 0 && item.startMin >= groupEnd)
            closeGroup();
        // Die erste Spalte, deren letzter Termin schon zu Ende ist
        const taken = new Set(group.filter((b) => b.endMin > item.startMin).map((b) => b.column));
        let column = 0;
        while (taken.has(column))
            column++;
        group.push({ ...item, column, columns: 1 });
        groupEnd = Math.max(groupEnd, item.endMin);
    }
    if (group.length > 0)
        closeGroup();
    return blocks;
}
/** Ganztägige Termine, die den Tag berühren (in der Zeile über dem Raster) */
export function allDayOn(appointments, day) {
    return appointments.filter((a) => a.allDay && a.start <= day && a.end >= day);
}
//# sourceMappingURL=layout.js.map